import { State } from './types';

export const state: State = {
    solarPanels: [],
};
